import React from 'react';
import { Modal, AutoComplete, Typography, Input, Space } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const ModalRectificacion = ({
  visible,
  onOk,
  onCancel,
  loading,
  selectedRectificacion,
  onSelectionChange,
  opcionesRectificacion,
  argumento,
  onArgumentoChange
}) => {
  return (
    <Modal
      title={
        <div style={{ textAlign: 'center' }}>
          <ExclamationCircleOutlined style={{ color: '#f5576c', marginRight: 8 }} />
          <span style={{ color: '#f5576c', fontWeight: 'bold' }}>Seleccionar Tipo de Rectificación</span>
        </div>
      }
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText="Ejecutar Rectificación"
      cancelText="Cancelar"
      okButtonProps={{
        loading,
        disabled: !selectedRectificacion,
        style: {
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          border: 'none',
          borderRadius: '6px'
        }
      }}
      cancelButtonProps={{
        style: {
          borderRadius: '6px'
        }
      }}
      width={600}
    >      <div style={{ padding: '20px 0' }}>
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <div>
            <Text style={{ fontSize: '14px', color: '#595959', marginBottom: 16, display: 'block' }}>
              Seleccione el tipo de rectificación que desea ejecutar:
            </Text>
            
            <AutoComplete
              style={{ width: '100%' }}
              size="large"
              placeholder="Buscar tipo de rectificación..."
              value={selectedRectificacion}
              onChange={onSelectionChange}
              options={opcionesRectificacion.map(opcion => ({
                value: opcion.value,
                label: (
                  <div style={{ padding: '8px 0' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#262626' }}>
                      {opcion.label}
                    </div>
                    <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: 4 }}>
                      {opcion.description}
                    </div>
                  </div>
                )
              }))}
              filterOption={(inputValue, option) =>
                option.value.toLowerCase().includes(inputValue.toLowerCase()) ||
                opcionesRectificacion.find(opt => opt.value === option.value)?.label
                  .toLowerCase().includes(inputValue.toLowerCase())
              }
            />
          </div>

          <div>
            <Text style={{ fontSize: '14px', color: '#595959', marginBottom: 8, display: 'block' }}>
              Argumento (opcional):
            </Text>
            <Input
              size="large"
              placeholder="Ingrese un argumento adicional (opcional)"
              value={argumento}
              onChange={(e) => onArgumentoChange(e.target.value)}
              style={{
                borderRadius: '6px',
                border: '1px solid #d9d9d9'
              }}
            />
          </div>
        </Space>        {selectedRectificacion && (
          <div style={{ 
            marginTop: 16, 
            padding: 12, 
            background: '#f6ffed', 
            border: '1px solid #b7eb8f',
            borderRadius: '6px'
          }}>
            <Text style={{ fontSize: '13px', color: '#389e0d' }}>
              <strong>Seleccionado:</strong> {opcionesRectificacion.find(opt => opt.value === selectedRectificacion)?.label}
            </Text>
            <br />
            <Text style={{ fontSize: '12px', color: '#52c41a' }}>
              {opcionesRectificacion.find(opt => opt.value === selectedRectificacion)?.description}
            </Text>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalRectificacion;
